<div class="modaloverlay" [class.hasoverlay]="showOverlay"
  [class.visibleoverlay]="showOverlay && overlayVisible" [class.notdisplayed]="!visible">
  <div class="modalcomponent" *ngIf="modalVisible">
    <div class="closeicon" *ngIf="showClose">
      <fa-icon [icon]="faClose" (click)="hide()"></fa-icon>
    </div>
    <ng-content></ng-content>
  </div>
</div>
